module.exports = __webpack_public_path__ + "static/media/tubular_key.e675bc5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/tubular_key.png
// module id = 1195
// module chunks = 0